'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon$1 = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
var pill = require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
var privacy = require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var fontIcon = require('../../../atoms/icon/font-icon/font-icon.js');
require('@brandfolder/utilities');
var badgePill = require('../../../atoms/pill/badge/badge-pill.js');
var circleStatus = require('../../../atoms/status/circle/circle-status.js');
var privacyBadge_module = require('./styles/privacy-badge.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const baseName = 'privacy-badge';
const PrivacyBadge = (props)=>{
    const { children , privacyLevel , showIcon =false , showText =true  } = props;
    const privacyIcon = ()=>{
        if (privacyLevel.includes(privacy.Privacy.Private)) {
            return /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, {
                className: classnames__default.default(privacyBadge_module[`bf-${baseName}__icon`]),
                icon: fontIcon$1.FontIcons.Private,
                iconSize: 11
            });
        } else if (privacyLevel.includes(privacy.Privacy.Stealth)) {
            return /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, {
                className: classnames__default.default(privacyBadge_module[`bf-${baseName}__icon`]),
                icon: fontIcon$1.FontIcons.Private,
                iconSize: 11
            });
        } else {
            return /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, {
                className: classnames__default.default(privacyBadge_module[`bf-${baseName}__icon`]),
                icon: fontIcon$1.FontIcons.Public,
                iconSize: 11
            });
        }
    };
    const privacyText = ()=>{
        const privateText = privacyLevel.includes(privacy.Privacy.Private);
        const stealthText = privacyLevel.includes(privacy.Privacy.Stealth);
        if (privateText) {
            return /*#__PURE__*/ React__default.default.createElement("span", {
                className: classnames__default.default(privacyBadge_module[`bf-${baseName}__label`])
            }, children);
        } else if (stealthText) {
            return /*#__PURE__*/ React__default.default.createElement("span", {
                className: classnames__default.default(privacyBadge_module[`bf-${baseName}__label`])
            }, children);
        } else {
            return /*#__PURE__*/ React__default.default.createElement("span", {
                className: classnames__default.default(privacyBadge_module[`bf-${baseName}__label`])
            }, children);
        }
    };
    return /*#__PURE__*/ React__default.default.createElement(badgePill.BadgePill, {
        className: classnames__default.default(`bf-${baseName}`, privacyBadge_module[`bf-${baseName}`]),
        backgroundColor: colors.BrandfolderHexColors.DirtyMarshmallow,
        size: pill.PillSize.XSmall
    }, /*#__PURE__*/ React__default.default.createElement(circleStatus.CircleStatus, {
        className: classnames__default.default(privacyBadge_module[`bf-status__circle--${privacyLevel}`]),
        size: 7
    }), showIcon && privacyIcon(), showText && privacyText());
};

exports.PrivacyBadge = PrivacyBadge;
//# sourceMappingURL=privacy-badge.js.map
